const pairs = []

const apply = (target, source) => {
  target.style.setProperty('--sync-height', `${source.offsetHeight * 1.15}px`)
}

const observer = new ResizeObserver(entries => {
  for (const entry of entries) {
    for (const { target, source } of pairs) {
      if (source === entry.target) apply(target, source)
    }
  }
})

document.querySelectorAll('[data-sync-height]').forEach(target => {
  const selector = target.dataset.syncHeight
  if (!selector) return
  const source = document.querySelector(selector)
  if (!source) return
  pairs.push({ target, source })
  observer.observe(source)
  apply(target, source)
})
